import { FieldPath } from "Utils/nameof";
import classNames from "classnames";
import React from "react";
import { FieldValues, FieldErrors } from "react-hook-form";

export interface ValidationSummaryProps<T extends FieldValues> {
   errors?: FieldErrors<T>,
   className?: string;
   fields?: Array<FieldPath<T>>;
   serverErrors?: Array<[FieldPath<T> | string, string]>;
   includeFormErrors?: boolean;
}

export const ValidationSummary = <T extends FieldValues>({ errors, fields, className, serverErrors, includeFormErrors = false }: ValidationSummaryProps<T>) => {
   const wrapperClasses = classNames(
      "validation-summary",
      className,
   );

   /*TODO: fix (error as any)*/

   const errorsMessages = (includeFormErrors && errors ? Object.entries(errors) : [])
      .concat(serverErrors ? serverErrors.map(([sf, se]) => [sf, { message: se }]) : [])
      .filter(([field]) => !fields || fields.includes(field as any))
      .map(([field, error], index) => (<div key={`${field}-${index}`} className="validation-summary-entry">{(error as any).message}</div>))
   
   return (
      errorsMessages.length
         ?
         <div role="alert" className={wrapperClasses}>
            {errorsMessages}
         </div>
         : null
   )
}